import React from 'react';
import { CollaboratorCombobox } from '@/components/shared';

export interface DonoTermo {
  /** null = ainda não escolheu (não deixa anexar). */
  modo: 'colaborador' | 'antigo' | null;
  colaborador: { id: string; name: string } | null;
}

export const DONO_TERMO_VAZIO: DonoTermo = { modo: null, colaborador: null };

export function donoTermoValido(dono: DonoTermo): boolean {
  return dono.modo === 'antigo' || (dono.modo === 'colaborador' && Boolean(dono.colaborador));
}

interface TermoDonoCampoProps {
  valor: DonoTermo;
  onChange: (valor: DonoTermo) => void;
  /** Quem está com o equipamento hoje — atalho (o caso mais comum). */
  responsavelAtual: { id: string; name: string } | null;
}

/**
 * "De quem é este termo?" — obrigatório ao anexar um Termo na ficha. É o que decide quem vê
 * o termo em "Meus equipamentos": termos antigos de outras pessoas ficam guardados sem dono.
 */
export default function TermoDonoCampo({ valor, onChange, responsavelAtual }: TermoDonoCampoProps) {
  return (
    <fieldset className="w-full space-y-2 rounded-md bg-gray-50 p-3 text-sm">
      <legend className="sr-only">De quem é este termo?</legend>
      <p className="font-medium text-gray-700">De quem é este termo?</p>
      <label className="flex items-center gap-2">
        <input
          type="radio"
          checked={valor.modo === 'colaborador'}
          onChange={() => onChange({ modo: 'colaborador', colaborador: valor.colaborador ?? responsavelAtual })}
        />
        Do colaborador atual — ele passa a ver em &quot;Meus equipamentos&quot;
      </label>
      {valor.modo === 'colaborador' && (
        <div className="ml-6 space-y-1">
          <CollaboratorCombobox
            selectedId={valor.colaborador?.id ?? null}
            onChange={(c) => onChange({ modo: 'colaborador', colaborador: c ? { id: c.id, name: c.name } : null })}
            placeholder="Buscar colaborador..."
          />
          {responsavelAtual && valor.colaborador?.id !== responsavelAtual.id && (
            <button
              type="button"
              className="text-xs font-semibold text-blue-700 hover:underline"
              onClick={() => onChange({ modo: 'colaborador', colaborador: responsavelAtual })}
            >
              Usar quem está com o equipamento: {responsavelAtual.name}
            </button>
          )}
        </div>
      )}
      <label className="flex items-center gap-2">
        <input type="radio" checked={valor.modo === 'antigo'} onChange={() => onChange({ modo: 'antigo', colaborador: null })} />
        Termo antigo de outra pessoa — fica na ficha, ninguém vê
      </label>
    </fieldset>
  );
}
